import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { CommonEnums } from 'src/app/shared/common.enums';
import { Attribute } from 'src/app/shared/models/domain/attribute';

export class RestWrapper extends DatabaseWrapper {

    constructor(database: Database) {
        super(database);

        this.dbTyp_Id = DatabaseEnum.rest.ID;
        this.name = DatabaseEnum.rest.NAME;
        this.code = DatabaseEnum.rest.CODE;
        this.equivalentTag = DatabaseEnum.rest.EQUIVALENT_TAG;
        this.showRestPropertiesTab = true;
        this.showDatabaseTab = false;
        this.showLoadPropertiesTab = false;
        this.importFileProperties();
        this.showDataDescription = false;
    }

    // validateRepConn(repConnWrapper: RepConnWrapper): void {

    //     if (repConnWrapper.repConn.conn.secAuth == 'No_Auth') {
    //         if (repConnWrapper.repConn.conn.destinationNm == "") {
    //             repConnWrapper.inValid_Cds.push('DEST_NM');
    //         }
    //     } else if (repConnWrapper.repConn.conn.secAuth == 'basic') {
    //         if (repConnWrapper.repConn.conn.url == "") {
    //             repConnWrapper.inValid_Cds.push('DEST_NM');
    //         }

    //         if (repConnWrapper.repConn.conn_Usr.conn_Usr == "") {
    //             repConnWrapper.inValid_Cds.push('NO_CONN_APPUSR');
    //         }

    //         if (repConnWrapper.repConn.conn_Usr.usrPasswd == "") {
    //             repConnWrapper.inValid_Cds.push('NO_PASSWORD');
    //         }
    //     } else if (repConnWrapper.repConn.conn.secAuth == 'OAuth_1.0') {

    //     } else if (repConnWrapper.repConn.conn.secAuth == 'OAuth_2.0') {
    //         if (repConnWrapper.repConn.conn.destinationNm == "") {
    //             repConnWrapper.inValid_Cds.push('DEST_NM');
    //         }

    //         if (repConnWrapper.repConn.conn.accessToken == "") {
    //             repConnWrapper.inValid_Cds.push('ACCESS_KEY');
    //         }
    //     }
    //     else if (repConnWrapper.repConn.conn.secAuth == 'Mutual TLS' &&
    //         repConnWrapper.repConn.conn.queueNm == 'REST' &&
    //         repConnWrapper.repConn.conn.cs_SSL_Flag == 'N') {
    //         if (repConnWrapper.repConn.conn.url == "") {
    //             repConnWrapper.inValid_Cds.push('DEST_NM');
    //         }
    //         if (repConnWrapper.repConn.conn.ssl_keyStore == "") {
    //             repConnWrapper.inValid_Cds.push('KEY_STORE');
    //         }

    //         if (repConnWrapper.repConn.conn.ssl_keyStorePassword == "") {
    //             repConnWrapper.inValid_Cds.push('KEY_STORE_PASSWORD');
    //         }
    //         if (repConnWrapper.repConn.conn.ssl_trustStore == "") {
    //             repConnWrapper.inValid_Cds.push('TRUST_STORE');
    //         }

    //         if (repConnWrapper.repConn.conn.ssl_trustStorePassword == "") {
    //             repConnWrapper.inValid_Cds.push('TRUST_STORE_PASSWORD');
    //         }

    //     }
    //     else if (repConnWrapper.repConn.conn.secAuth == 'Mutual TLS' &&
    //         repConnWrapper.repConn.conn.cs_SSL_Flag == 'Y') {
    //         if (repConnWrapper.repConn.conn.url == "") {
    //             repConnWrapper.inValid_Cds.push('DEST_NM');
    //         }
    //     }

    //     if (repConnWrapper.repConn.conn.flagent_Id == -1) {
    //         repConnWrapper.inValid_Cds.push('ESM00202');
    //     }
    // }

    getAttributeColumns(objectWrapper: ObjectWrapper,
        attributes: Array<Attribute> = new Array<Attribute>(), component: any = null, hideRowSelection: boolean = true): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper, hideRowSelection),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getAttrNm(objectWrapper,component),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getNotNullFlag(objectWrapper),
            this.attributeTabulator.getAttrKeyTyp_Id(objectWrapper),
            this.attributeTabulator.getDescription(objectWrapper),
        ]
    }

    getSourceAttributeColumns(objectWrapper: ObjectWrapper = null, isComplex: boolean = false, isShowPIIColumn: boolean = false, isGoogleAnalytics: boolean = false, component: any): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getClevel(objectWrapper, isComplex),
            this.attributeTabulator.getAttrNm(objectWrapper,component),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, isShowPIIColumn),
            this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
            this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
            this.attributeTabulator.getValid_Cd(objectWrapper, component),
        ]
    }

    importFileProperties() {
        this.showFileTypeGroup = true;
        this.showDelimiter = true;
        this.showFixedWidth = true;
    }

    readFileCutOffLength(type: string): number {
        if (type == "FILE") {
            return 49; //default 50 lines index starts from 0
        }

        return -1;
    }
}
